import api from './api'
import { getAll } from './pagination'

export interface AcademicYear {
  id: number
  name: string
  start_date: string
  end_date: string
  is_current: boolean
}

export interface AcademicTerm {
  id: number
  academic_year: number
  academic_year_name: string
  term: 'term_1' | 'term_2' | 'term_3'
  start_date: string
  end_date: string
  is_current: boolean
  mid_term_break_start?: string | null
  mid_term_break_end?: string | null
}

export const academicSetupService = {
  getYears: async () => getAll<AcademicYear>('/auth/academic-years/'),
  createYear: async (data: Omit<AcademicYear, 'id'>) => (await api.post('/auth/academic-years/', data)).data as AcademicYear,
  updateYear: async (id: number, data: Partial<AcademicYear>) => (await api.patch(`/auth/academic-years/${id}/`, data)).data as AcademicYear,
  getTerms: async () => getAll<AcademicTerm>('/academics/uganda/terms/'),
  createTerm: async (data: Omit<AcademicTerm, 'id' | 'academic_year_name'>) => (await api.post('/academics/uganda/terms/', data)).data as AcademicTerm,
  updateTerm: async (id: number, data: Partial<AcademicTerm>) => (await api.patch(`/academics/uganda/terms/${id}/`, data)).data as AcademicTerm,
  /** With `in_use`: what deleting the term would touch. */
  getTerm: async (id: number) => (await api.get(`/academics/uganda/terms/${id}/`)).data as AcademicTerm & { in_use: Record<string, number> },
  deleteTerm: async (id: number) => { await api.delete(`/academics/uganda/terms/${id}/`) },
}
